<template>
  <a-card size="small">
    <template #title>待选列表 - {{ value.length }}项</template>
    <template #extra>
      <a-button size="small" type="link" @click="remove">删除选中</a-button>
    </template>
    <table-wrapper
      :row-key="'materialId'"
      size="small"
      ref="tableRef"
      :bordered="true"
      :data-source="value"
      :columns="columns"
      @onSelectionChange="onSelectionChange"
      :tableHeight="tableHeight2"
    ></table-wrapper>
  </a-card>
</template>

<script lang="ts">
import { defineComponent, PropType, reactive, toRefs,Ref,computed } from "vue";
import { columns } from "./constant";
import { MaterialRecord } from "@/views/purchase/receive/receive.interface";

export default defineComponent({
  name: "SelectedTable",
  props: {
    value: {
      type: Array as PropType<MaterialRecord[]>,
      default: [],
    },
    tableHeight:{
      type:Number,
      default:0
    },
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    const state = reactive<{
      current: number;
      selectedIds: string[];
      columns: any[];
       tableHeight2:Ref<Number>;
    }>({
      current: 1,
      selectedIds: [],
      columns,
      tableHeight2:computed(()=>{
        return props.tableHeight-20;
      })
    });

    const onSelectionChange = (ids: string[]) => {
      state.selectedIds = ids;
    };

    const onTableChange = async (pagination) => {
      state.current = pagination.current;
    };

    const remove = () => {
      const newValue = (props.value || []).filter(
        (item) => !state.selectedIds.includes(item.materialId)
      );
      emit("update:value", newValue);
    };

    return {
      ...toRefs(state),
      onSelectionChange,
      onTableChange,
      remove,
    };
  },
});
</script>
